module.exports = __webpack_public_path__ + "img/jjian.de0a32cc.png";